import { type MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from 'owa-session-store';

export function canUpdatePhoto(viewerMailboxInfo: MailboxInfo): boolean {
    const accountScopeUserSettings = getAccountScopeUserSettings(viewerMailboxInfo);
    return accountScopeUserSettings.SegmentationSettings?.SetPhoto ?? false;
}
